// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"787":"42c32afc","845":"e4511cc5"}[chunkId] + ".chunk.js";
};